import React, { useContext } from 'react'

import { DeleteOutlined, DownOutlined, NotificationOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space, Table, Tag } from 'antd'

import createOperation from '../marketing/operations/MarketingOperationCreate';
import confirmModal from '../DiConfirmModal';


export default function TableAudience({ contextValue, data, loading, rowSelection, hideRowSelection}) {
   
   const userColumns = [
   {
      title: 'ID',
      dataIndex: 'idCustomer',
      key: 'idCustomer',
   },
   {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
   },
   {
      title: 'Cognome / Ragione Sociale',
      dataIndex: 'surname',
      key: 'surname',
   },
   {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
   },
   {
      title: 'Genere',
      dataIndex: 'gender',
      key: 'gender',
      render: (value) => {
         if (value === 'M') return 'Maschio';
         if (value === 'F') return 'Femmina';
         if (value === 'A') return 'Altro';
         return '-';
      },
   },
    {
      title: 'Pubblico di appartenenza',
      dataIndex: 'audiences',
      key: 'audiences',
      render: (audiences) => {
         if (!Array.isArray(audiences) || audiences.length === 0) {
            return  <Tag color='red'>Nessun'appartenenza</Tag>;
         }

         if (audiences.length === 1) {
            return <Tag>{audiences[0].title}</Tag>;
         }

         return (
            <Dropdown
               overlayClassName="ant-dropdown-link"
               menu={{
               items: audiences.map((audience) => ({
                  label: audience.title,
                  key: audience.id,
               })),
               }}
               trigger={['click']}
            >
               <a onClick={(e) => e.preventDefault()}>
               <Space>
                  Visualizza pubblico
                  <DownOutlined />
               </Space>
               </a>
            </Dropdown>
         );
      }
   },
   {
      title: 'Data di nascita',
      dataIndex: 'birth_data',
      key: 'birth_data',
      render: (date) => date ? new Date(date).toLocaleDateString('it-IT') : '-',
   },
   {
      title: 'Data creazione',
      dataIndex: 'dateCreation',
      key: 'dateCreation',
      render: (date) => date ? new Date(date).toLocaleString('it-IT') : '-',
   },
   ];



   const handleEdit = (record) => {
      console.log('Editing user:', record);
      // Add your edit functionality here
      createOperation(contextValue,null,record.id)
   };

   const handleDelete = async (record) => {
      console.log('Inizio la cancellazione');
      // Add your edit functionality here

      
      const result = await confirmModal(
         "Stai per rimuovere questo utente dal pubblico. Non riceverà più operazioni, Vuoi comunque procedere?",
         contextValue
      ); //attendo la risposta dal componente di conferma modale

      if (result) {
         console.log('Cancello utente con ID:', record.id); 
      } else {
         console.log("Non cancello");
      }
   };
   
   return (
      <Table
         className='di-audience-table'
         rowSelection={!hideRowSelection && rowSelection}
         scroll={{ x:'max-content'}} 
         columns={userColumns}
         pagination={false}
         dataSource={data}
         loading={loading}
         bordered
      />
  )
}
